"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeritextApi = void 0;
const Peritext_1 = require("./Peritext");
const printTree_1 = require("tree-dump/lib/printTree");
const ExtensionApi_1 = require("../../json-crdt/extensions/ExtensionApi");
const PeritextHeadless_1 = require("./PeritextHeadless");
class PeritextApi extends ExtensionApi_1.ExtensionApi {
    /**
     * Returns the default shared {@link Peritext} instance.
     *
     * @deprecated Use {@link PeritextApi#peritext} instead.
     */
    get txt() {
        if (!this._txt)
            this._txt = this.peritext();
        return this._txt;
    }
    constructor(node, api) {
        super(node, api);
        this.node = node;
        this.api = api;
    }
    peritext() {
        return new Peritext_1.Peritext(this.api.model, this.node.text(), this.node.slices());
    }
    headless(opts) {
        const txt = this.peritext();
        const headless = new PeritextHeadless_1.PeritextHeadless(txt, opts);
        return headless;
    }
    text() {
        return this.api.wrap(this.node.text());
    }
    slices() {
        return this.api.wrap(this.node.slices());
    }
    toString(tab) {
        return ('PeritextApi' + (0, printTree_1.printTree)(tab, [(tab) => this.node.toString(tab), () => '', (tab) => this.txt.toString(tab)]));
    }
}
exports.PeritextApi = PeritextApi;
